
import { Form, FormElement } from '05-ui-kit';
import { computed } from '@nuxtjs/composition-api';
import type { CheckoutPayment } from '~/type/Checkout';
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: false,
    type: Number
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const current = computed(() => {
    return props.list?.find(el => el.id === props.value);
  });
  function onChange(id: number) {
    const type = props.list?.find(el => el.id === id);
    emit('change', {
      type
    });
  }
  return {
    current,
    onChange
  };
};
__sfc_main.components = Object.assign({
  Form,
  FormElement
}, __sfc_main.components);
export default __sfc_main;
